module.exports = __webpack_public_path__ + "static/media/Barlow-Light.0af418dc.ttf";